import React from 'react';
import "../css/project.css";
import { Link, useLocation } from 'react-router-dom';

const Project = () => {
   const location = useLocation();
   const project = location.state.project;

   return (
      <React.Fragment>
         <div className="project-main-content" id="project">
            <Link to="/projects/">back</Link>
            <div className="project-project">
               <img src={project.image}></img>
               <div className="project-details">
                  <h3>{project.title}</h3>
                  {project.siteLink ? <a href={project.siteLink} target="_blank">{project.siteLink}</a> : null}
                  <div className="project-details-section">
                     {project.summary ? <h6>Summary</h6> : null}
                     {project.summary ? <p>{project.summary}</p> : null}
                  </div>
                  <div className="project-details-section">
                     {project.reflection ? <h6>Reflection</h6> : null}
                     {project.reflection ? <p>{project.reflection}</p> : null}
                  </div>
               </div>
            </div>
         </div>
         <div className="project-main-content" id="project-mobile">
            <Link to="/projects/">back</Link>
            <div className="project-project">
               <div className="project-details">
                  <h3>{project.title}</h3>
                  {project.siteLink ? <a href={project.siteLink} target="_blank">{project.siteLink}</a> : null}
                  <img src={project.image}></img>
                  <div className="project-details-section">
                     {project.summary ? <h6>Summary</h6> : null}
                     {project.summary ? <p>{project.summary}</p> : null}
                  </div>
                  <div className="project-details-section">
                     {project.reflection ? <h6>Reflection</h6> : null}
                     {project.reflection ? <p>{project.reflection}</p> : null}
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   );
}

export default Project;